module.exports = __webpack_public_path__ + "df_backdrop.jpg?1e96f99910f077e3e65f4170ac2b1e4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/df_backdrop.jpg
// module id = 49
// module chunks = 0